import { render, staticRenderFns } from "./coreHtml.vue?vue&type=template&id=ca8874e8"
import script from "./coreHtml.vue?vue&type=script&lang=js"
export * from "./coreHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports